import React, { Component } from "react";
import "./styles/main.scss";
import { Provider } from "react-redux";
import Router from "./components/Router";
import store from "./store";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import "es6-promise/auto";
require("es6-promise").polyfill();

export default class App extends Component {
  
  // fake authentication Promise
  authenticate(){
    return new Promise(resolve => setTimeout(resolve, .005)) // 2 seconds
  }
  
  componentDidMount(){
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator")
      if(ele){
        // fade out
        ele.style.display = "none";
        ele.outerHTML = "";
      }
    })
  }
  
  render() {
    return (
      <Provider store={store}>
        <Router />
        <ToastContainer
          className="toast-container"
          toastClassName="dark-toast"
          bodyClassName="toast-body"
          position="top-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          pauseOnHover
        />
      </Provider>
    );
  }
}
